import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useCustomer, useUpdateCustomer } from "../hooks";
import { CustomerForm } from "../components";

type IUpdateCustomer = {
  id: string;
};

export const UpdateCustomer: React.FC = () => {
  const { id } = useParams<IUpdateCustomer>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useCustomer(+id!);
  const { form, submit, loading } = useUpdateCustomer({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le client a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.customer?.ok && data?.customer?.result) {
      const { result } = data.customer;
      form.setValue("name", result.name);
      form.setValue("email", result.email ?? undefined);
      form.setValue("phone", result.phone);
      form.setValue("status", result.status);
      form.setValue("callStatus", result.callStatus ?? undefined);
      form.setValue("site", result.site ?? undefined);
      form.setValue("address", result.address ?? undefined);
      form.setValue("postalCode", result.postalCode ?? undefined);
      form.setValue("city", result.city ?? undefined);
      form.setValue("findBy", result.findBy ?? undefined);
      form.setValue("todo", result.todo ?? undefined);
      form.setValue("note", result.note ?? undefined);
      form.setValue("analyseDone", result.analyseDone);
      form.setValue("problemsDetected", result.problemsDetected);
      form.setValue("categoryId", result.categoryId ?? undefined);
      form.setValue("cmsId", result.cmsId ?? undefined);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Client"
        subtitle={data?.customer?.result?.name}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/customer/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un client" />
          <CustomerForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
